
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';


// const HomeComponent = lazy(() => import('../../pages/Home/containers/HomePageContainer'));
import HomeComponent from '../../pages/Home/containers/HomePageContainer';

const route = [
  {
    path: ROUTERS.HOME,
    title: 'Home',
    exact: true,
    public: false,
    component: <HomeComponent />,
  }
];

export default route;